/* eslint-disable */
import { Localizable } from '@salsita-ai/platform-common/utils'
import {
  AjvReflection,
  DomainEntityId,
  DomainEntityReflection,
  EntityReflections,
  EnumLike,
  EnumReflection,
  RawAliasReflection,
  SchemaOfObject,
} from '@salsita-ai/platform-project-sdk/domain'

export const modelVersion = 9

export type WallType = 'A' | 'B' | 'C'
export const WallType: EnumLike<WallType> = new EnumReflection('WallType', {
  enum: ['A', 'B', 'C'],
}) as EnumLike<WallType>

export type WallDirection = 'left' | 'right'
export const WallDirection: EnumLike<WallDirection> = new EnumReflection('WallDirection', {
  enum: ['left', 'right'],
}) as EnumLike<WallDirection>

export type CornerFillerType = 'AB' | 'BC'
export const CornerFillerType: EnumLike<CornerFillerType> = new EnumReflection('CornerFillerType', {
  enum: ['AB', 'BC'],
}) as EnumLike<CornerFillerType>

export type Handing = 'left' | 'right' | 'top' | 'both' | 'none'
export const Handing: EnumLike<Handing> = new EnumReflection('Handing', {
  enum: ['left', 'right', 'top', 'both', 'none'],
}) as EnumLike<Handing>

export type RoomShapeType = 'L' | 'U' | 'I'
export const RoomShapeType: EnumLike<RoomShapeType> = new EnumReflection('RoomShapeType', {
  enum: ['L', 'U', 'I'],
}) as EnumLike<RoomShapeType>

export type CabinetColor =
  | 'Obsidian'
  | 'Glacier'
  | 'PacificBlue'
  | 'CaliforniaPoppy'
  | 'Surf'
  | 'DesertSage'
  | 'Limestone'
  | 'Sierra'
export const CabinetColor: EnumLike<CabinetColor> = new EnumReflection('CabinetColor', {
  type: 'string',
  enum: ['Obsidian', 'Glacier', 'PacificBlue', 'CaliforniaPoppy', 'Surf', 'DesertSage', 'Limestone', 'Sierra'],
}) as EnumLike<CabinetColor>

export type FuelType = 'None' | 'Propane' | 'NaturalGas'
export const FuelType: EnumLike<FuelType> = new EnumReflection('FuelType', {
  type: 'string',
  enum: ['None', 'Propane', 'NaturalGas'],
}) as EnumLike<FuelType>

export type GrillBaseVariant = 'Default' | 'WithWarmingDrawer'
export const GrillBaseVariant: EnumLike<GrillBaseVariant> = new EnumReflection('GrillBaseVariant', {
  type: 'string',
  enum: ['Default', 'WithWarmingDrawer'],
}) as EnumLike<GrillBaseVariant>

export type LynxProfessionalGrillVariant = 'AllCeramic' | 'AllTrident' | 'TridentAndCeramic'
export const LynxProfessionalGrillVariant: EnumLike<LynxProfessionalGrillVariant> = new EnumReflection(
  'LynxProfessionalGrillVariant',
  {
    type: 'string',
    enum: ['AllCeramic', 'AllTrident', 'TridentAndCeramic'],
  }
) as EnumLike<LynxProfessionalGrillVariant>

export type LynxSedonaGrillVariant =
  | 'ProSear_SsBurner1'
  | 'ProSear_SsBurner1_Rotisserie'
  | 'SsBurner3'
  | 'ProSear_SsBurner2'
  | 'SsBurner3_Rotisserie'
  | 'ProSear_SsBurner2_Rotisserie'
export const LynxSedonaGrillVariant: EnumLike<LynxSedonaGrillVariant> = new EnumReflection('LynxSedonaGrillVariant', {
  type: 'string',
  enum: [
    'ProSear_SsBurner1',
    'ProSear_SsBurner1_Rotisserie',
    'SsBurner3',
    'ProSear_SsBurner2',
    'SsBurner3_Rotisserie',
    'ProSear_SsBurner2_Rotisserie',
  ],
}) as EnumLike<LynxSedonaGrillVariant>

export type PowderCoatType = 'Anvil' | 'Swatch' | 'Pulse'
export const PowderCoatType: EnumLike<PowderCoatType> = new EnumReflection('PowderCoatType', {
  type: 'string',
  enum: ['Anvil', 'Swatch', 'Pulse'],
}) as EnumLike<PowderCoatType>

export interface WallSummaryItem {
  readonly id: string
  readonly name: Localizable
  readonly sku: string
  readonly dealerPrice: number
  readonly retailPrice: number
  readonly currentUserPrice: number
  readonly thumbnailUrl?: string
  readonly packageDepth: number
  readonly packageHeight: number
  readonly packageWidth: number
  readonly packageWeight: number
  readonly color?: CabinetColor
}
export const WallSummaryItem: AjvReflection<WallSummaryItem> = new AjvReflection('WallSummaryItem', {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      anyOf: [
        {
          type: 'string',
        },
        {
          type: 'object',
          properties: {
            id: {
              type: 'string',
            },
            comment: {
              type: 'string',
            },
            message: {
              type: 'string',
            },
            values: {
              type: 'object',
              additionalProperties: true,
            },
          },
          required: ['id'],
          additionalProperties: false,
        },
      ],
    },
    sku: {
      type: 'string',
    },
    dealerPrice: {
      type: 'number',
    },
    retailPrice: {
      type: 'number',
    },
    currentUserPrice: {
      type: 'number',
    },
    thumbnailUrl: {
      type: 'string',
    },
    packageDepth: {
      type: 'number',
    },
    packageHeight: {
      type: 'number',
    },
    packageWidth: {
      type: 'number',
    },
    packageWeight: {
      type: 'number',
    },
    color: CabinetColor._meta.schema,
  },
  required: [
    'id',
    'name',
    'sku',
    'dealerPrice',
    'retailPrice',
    'currentUserPrice',
    'packageDepth',
    'packageHeight',
    'packageWidth',
    'packageWeight',
  ],
  additionalProperties: false,
})

export interface WallSummary {
  readonly id: string
  readonly name: Localizable
  readonly cabinets: readonly WallSummaryItem[]
  readonly parts: readonly WallSummaryItem[]
  readonly appliances: readonly WallSummaryItem[]
  readonly dealerPrices: {
    readonly appliances: number
    readonly cabinetsAndParts: number
  }
  readonly retailPrices: {
    readonly appliances: number
    readonly cabinetsAndParts: number
  }
  readonly currentUserPrice?: {
    readonly appliances: number
    readonly cabinetsAndParts: number
  }
}
export const WallSummary: AjvReflection<WallSummary> = new AjvReflection('WallSummary', {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    name: {
      anyOf: [
        {
          type: 'string',
        },
        {
          type: 'object',
          properties: {
            id: {
              type: 'string',
            },
            comment: {
              type: 'string',
            },
            message: {
              type: 'string',
            },
            values: {
              type: 'object',
              additionalProperties: true,
            },
          },
          required: ['id'],
          additionalProperties: false,
        },
      ],
    },
    cabinets: {
      type: 'array',
      items: WallSummaryItem._meta.schema,
    },
    parts: {
      type: 'array',
      items: WallSummaryItem._meta.schema,
    },
    appliances: {
      type: 'array',
      items: WallSummaryItem._meta.schema,
    },
    dealerPrices: {
      type: 'object',
      properties: {
        appliances: {
          type: 'number',
        },
        cabinetsAndParts: {
          type: 'number',
        },
      },
      additionalProperties: false,
      required: ['appliances', 'cabinetsAndParts'],
    },
    retailPrices: {
      type: 'object',
      properties: {
        appliances: {
          type: 'number',
        },
        cabinetsAndParts: {
          type: 'number',
        },
      },
      additionalProperties: false,
      required: ['appliances', 'cabinetsAndParts'],
    },
    currentUserPrice: {
      type: 'object',
      properties: {
        appliances: {
          type: 'number',
        },
        cabinetsAndParts: {
          type: 'number',
        },
      },
      additionalProperties: false,
      required: ['appliances', 'cabinetsAndParts'],
    },
  },
  required: ['id', 'name', 'cabinets', 'parts', 'appliances', 'dealerPrices', 'retailPrices', 'currentUserPrices'],
  additionalProperties: false,
})

export interface Summary {
  readonly walls: readonly WallSummary[]
  readonly dealerPrices: {
    readonly appliances: number
    readonly cabinetsAndParts: number
  }
  readonly retailPrices: {
    readonly appliances: number
    readonly cabinetsAndParts: number
  }
  readonly currentUserPrices: {
    readonly appliances: number
    readonly cabinetsAndParts: number
  }
}
export const Summary: AjvReflection<Summary> = new AjvReflection('Summary', {
  type: 'object',
  properties: {
    walls: {
      type: 'array',
      items: WallSummary._meta.schema,
    },
    dealerPrices: {
      type: 'object',
      properties: {
        appliances: {
          type: 'number',
        },
        cabinetsAndParts: {
          type: 'number',
        },
      },
      additionalProperties: false,
      required: ['appliances', 'cabinetsAndParts'],
    },
    retailPrices: {
      type: 'object',
      properties: {
        appliances: {
          type: 'number',
        },
        cabinetsAndParts: {
          type: 'number',
        },
      },
      additionalProperties: false,
      required: ['appliances', 'cabinetsAndParts'],
    },
    currentUserPrices: {
      type: 'object',
      properties: {
        appliances: {
          type: 'number',
        },
        cabinetsAndParts: {
          type: 'number',
        },
      },
      additionalProperties: false,
      required: ['appliances', 'cabinetsAndParts'],
    },
  },
  required: ['walls', 'dealerPrices', 'retailPrices', 'currentUserPrices'],
  additionalProperties: false,
})

interface AdjustableDoorCabinetShape {
  readonly handing: Handing
}
const AdjustableDoorCabinetShape = new AjvReflection<AdjustableDoorCabinet, SchemaOfObject<AdjustableDoorCabinetShape>>(
  'AdjustableDoorCabinetShape',
  {
    type: 'object',
    properties: {
      handing: Handing._meta.schema,
    },
    additionalProperties: false,
    required: ['handing'],
  }
)

interface BottomAdjustableDoorApplianceShape {
  readonly handing: Handing
}
const BottomAdjustableDoorApplianceShape = new AjvReflection<
  BottomAdjustableDoorAppliance,
  SchemaOfObject<BottomAdjustableDoorApplianceShape>
>('BottomAdjustableDoorApplianceShape', {
  type: 'object',
  properties: {
    handing: Handing._meta.schema,
  },
  additionalProperties: false,
  required: ['handing'],
})

interface RearPanelShape {
  readonly wallId: Wall['id']
  readonly width:
    | 457.2
    | 609.6
    | 762
    | 914.4
    | 1066.8
    | 1219.2
    | 1371.6
    | 1524
    | 1676.4
    | 1828.8
    | 1981.2
    | 2133.6
    | 2286
    | 2438.4
}
const RearPanelShape = new AjvReflection<RearPanel, SchemaOfObject<RearPanelShape>>('RearPanelShape', {
  type: 'object',
  properties: {
    wallId: {
      type: 'string',
      pattern: '^[A-Z]\\w*-\\d+$',
    },
    width: {
      type: 'number',
      enum: [457.2, 609.6, 762, 914.4, 1066.8, 1219.2, 1371.6, 1524, 1676.4, 1828.8, 1981.2, 2133.6, 2286, 2438.4],
    },
  },
  additionalProperties: false,
  required: ['wallId', 'width'],
})

interface BottomCabinetWithApplianceShape {
  readonly applianceId: BottomCabinetAppliance['id'] | null
}
const BottomCabinetWithApplianceShape = new AjvReflection<
  BottomCabinetWithAppliance,
  SchemaOfObject<BottomCabinetWithApplianceShape>
>('BottomCabinetWithApplianceShape', {
  type: 'object',
  properties: {
    applianceId: {
      anyOf: [
        {
          type: 'string',
          pattern: '^[A-Z]\\w*-\\d+$',
        },
        {
          type: 'null',
        },
      ],
    },
  },
  additionalProperties: false,
  required: ['applianceId'],
})

interface WallItemShape {
  readonly wallId: Wall['id']
  readonly x: number
}
const WallItemShape = new AjvReflection<WallItem, SchemaOfObject<WallItemShape>>('WallItemShape', {
  type: 'object',
  properties: {
    wallId: {
      type: 'string',
      pattern: '^[A-Z]\\w*-\\d+$',
    },
    x: {
      type: 'number',
    },
  },
  additionalProperties: false,
  required: ['wallId', 'x'],
})

interface Drawer33Door66Shape {
  readonly width: 457.2 | 609.6
}
const Drawer33Door66Shape = new AjvReflection<Drawer33Door66, SchemaOfObject<Drawer33Door66Shape>>(
  'Drawer33Door66Shape',
  {
    type: 'object',
    properties: {
      width: {
        type: 'number',
        enum: [457.2, 609.6],
      },
    },
    additionalProperties: false,
    required: ['width'],
  }
)

interface FillerShape {
  readonly width:
    | 25.4
    | 31.75
    | 38.1
    | 44.45
    | 50.8
    | 57.15
    | 63.5
    | 69.85
    | 76.2
    | 82.55
    | 88.9
    | 95.25
    | 101.6
    | 107.95
    | 114.3
    | 120.65
    | 127
}
const FillerShape = new AjvReflection<Filler, SchemaOfObject<FillerShape>>('FillerShape', {
  type: 'object',
  properties: {
    width: {
      type: 'number',
      enum: [
        25.4, 31.75, 38.1, 44.45, 50.8, 57.15, 63.5, 69.85, 76.2, 82.55, 88.9, 95.25, 101.6, 107.95, 114.3, 120.65, 127,
      ],
    },
  },
  additionalProperties: false,
  required: ['width'],
})

interface FullDoorBaseShape {
  readonly width: 304.8 | 457.2 | 609.6
}
const FullDoorBaseShape = new AjvReflection<FullDoorBase, SchemaOfObject<FullDoorBaseShape>>('FullDoorBaseShape', {
  type: 'object',
  properties: {
    width: {
      type: 'number',
      enum: [304.8, 457.2, 609.6],
    },
  },
  additionalProperties: false,
  required: ['width'],
})

interface GrillBaseShape {
  readonly width: 914.4 | 1066.8 | 1219.2 | 1524
  readonly variant: GrillBaseVariant
  readonly warmingDrawerId: LynxWarmingDrawer['id'] | null
}
const GrillBaseShape = new AjvReflection<GrillBase, SchemaOfObject<GrillBaseShape>>('GrillBaseShape', {
  type: 'object',
  properties: {
    width: {
      type: 'number',
      enum: [914.4, 1066.8, 1219.2, 1524],
    },
    variant: GrillBaseVariant._meta.schema,
    warmingDrawerId: {
      anyOf: [
        {
          type: 'string',
          pattern: '^[A-Z]\\w*-\\d+$',
        },
        {
          type: 'null',
        },
      ],
    },
  },
  additionalProperties: false,
  required: ['width', 'variant', 'warmingDrawerId'],
})

interface LynxProfessionalOutdoorBeverageDispenserW24Shape {
  readonly towerKitId: LynxProfessionalSingleTapTowerKit['id'] | LynxProfessionalDoubleTapTowerKit['id']
}
const LynxProfessionalOutdoorBeverageDispenserW24Shape = new AjvReflection<
  LynxProfessionalOutdoorBeverageDispenserW24,
  SchemaOfObject<LynxProfessionalOutdoorBeverageDispenserW24Shape>
>('LynxProfessionalOutdoorBeverageDispenserW24Shape', {
  type: 'object',
  properties: {
    towerKitId: {
      anyOf: [
        {
          type: 'string',
          pattern: '^[A-Z]\\w*-\\d+$',
        },
        {
          type: 'string',
          pattern: '^[A-Z]\\w*-\\d+$',
        },
      ],
    },
  },
  additionalProperties: false,
  required: ['towerKitId'],
})

interface LynxProfessionalOutdoorIceMachineW15Shape {
  readonly drainPumpId: LynxProfessionalOutdoorIceMachineDrainPump['id']
}
const LynxProfessionalOutdoorIceMachineW15Shape = new AjvReflection<
  LynxProfessionalOutdoorIceMachineW15,
  SchemaOfObject<LynxProfessionalOutdoorIceMachineW15Shape>
>('LynxProfessionalOutdoorIceMachineW15Shape', {
  type: 'object',
  properties: {
    drainPumpId: {
      type: 'string',
      pattern: '^[A-Z]\\w*-\\d+$',
    },
  },
  additionalProperties: false,
  required: ['drainPumpId'],
})

interface LynxGrillShape {
  readonly variant: string
}
const LynxGrillShape = new AjvReflection<LynxGrill, SchemaOfObject<LynxGrillShape>>('LynxGrillShape', {
  type: 'object',
  properties: {
    variant: {
      type: 'string',
    },
  },
  additionalProperties: false,
  required: ['variant'],
})

interface LynxSinkShape {
  readonly width: 457.2 | 609.6 | 762
}
const LynxSinkShape = new AjvReflection<LynxSink, SchemaOfObject<LynxSinkShape>>('LynxSinkShape', {
  type: 'object',
  properties: {
    width: {
      type: 'number',
      enum: [457.2, 609.6, 762],
    },
  },
  additionalProperties: false,
  required: ['width'],
})

interface ApplianceWithPowderCoatingShape {
  readonly powderCoating: boolean
}
const ApplianceWithPowderCoatingShape = new AjvReflection<
  ApplianceWithPowderCoating,
  SchemaOfObject<ApplianceWithPowderCoatingShape>
>('ApplianceWithPowderCoatingShape', {
  type: 'object',
  properties: {
    powderCoating: {
      type: 'boolean',
    },
  },
  additionalProperties: false,
  required: ['powderCoating'],
})

interface RoomShape {
  readonly shape: RoomShapeType
  readonly powderCoatType: PowderCoatType
  readonly cabinetColor: CabinetColor
  readonly fuelType: FuelType
  readonly stainlessSafeEnvironment: boolean
}
const RoomShape = new AjvReflection<Room, SchemaOfObject<RoomShape>>('RoomShape', {
  type: 'object',
  properties: {
    shape: RoomShapeType._meta.schema,
    powderCoatType: PowderCoatType._meta.schema,
    cabinetColor: CabinetColor._meta.schema,
    fuelType: FuelType._meta.schema,
    stainlessSafeEnvironment: {
      type: 'boolean',
    },
  },
  additionalProperties: false,
  required: ['shape', 'powderCoatType', 'cabinetColor', 'fuelType', 'stainlessSafeEnvironment'],
})

interface SinkBaseShape {
  readonly width: 609.6 | 762 | 914.4 | 1219.2
}
const SinkBaseShape = new AjvReflection<SinkBase, SchemaOfObject<SinkBaseShape>>('SinkBaseShape', {
  type: 'object',
  properties: {
    width: {
      type: 'number',
      enum: [609.6, 762, 914.4, 1219.2],
    },
  },
  additionalProperties: false,
  required: ['width'],
})

interface ThreeDrawerBaseShape {
  readonly width: 457.2 | 609.6
}
const ThreeDrawerBaseShape = new AjvReflection<ThreeDrawerBase, SchemaOfObject<ThreeDrawerBaseShape>>(
  'ThreeDrawerBaseShape',
  {
    type: 'object',
    properties: {
      width: {
        type: 'number',
        enum: [457.2, 609.6],
      },
    },
    additionalProperties: false,
    required: ['width'],
  }
)

interface TrashPulloutBaseShape {
  readonly width: 457.2 | 609.6
}
const TrashPulloutBaseShape = new AjvReflection<TrashPulloutBase, SchemaOfObject<TrashPulloutBaseShape>>(
  'TrashPulloutBaseShape',
  {
    type: 'object',
    properties: {
      width: {
        type: 'number',
        enum: [457.2, 609.6],
      },
    },
    additionalProperties: false,
    required: ['width'],
  }
)

interface WallShape {
  readonly wallType: WallType
  readonly length: number
  readonly fullHeight: boolean
  readonly hidden: boolean
}
const WallShape = new AjvReflection<Wall, SchemaOfObject<WallShape>>('WallShape', {
  type: 'object',
  properties: {
    wallType: WallType._meta.schema,
    length: {
      type: 'number',
    },
    fullHeight: {
      type: 'boolean',
    },
    hidden: {
      type: 'boolean',
    },
  },
  additionalProperties: false,
  required: ['wallType', 'length', 'fullHeight', 'hidden'],
})

interface CornerFillerShape {
  readonly cornerFillerType: CornerFillerType
}
const CornerFillerShape = new AjvReflection<CornerFiller, SchemaOfObject<CornerFillerShape>>('CornerFillerShape', {
  type: 'object',
  properties: {
    cornerFillerType: CornerFillerType._meta.schema,
  },
  additionalProperties: false,
  required: ['cornerFillerType'],
})

export interface BurnerBaseW18 extends AdjustableDoorCabinetShape, BottomCabinetWithApplianceShape, WallItemShape {
  readonly id: DomainEntityId<'BurnerBaseW18'>
  readonly type: 'BurnerBaseW18'
}
export const BurnerBaseW18: DomainEntityReflection<BurnerBaseW18> = new DomainEntityReflection<BurnerBaseW18>(
  'BurnerBaseW18',
  [AdjustableDoorCabinetShape._meta.schema, BottomCabinetWithApplianceShape._meta.schema, WallItemShape._meta.schema]
)

export interface BurnerBaseW24 extends AdjustableDoorCabinetShape, BottomCabinetWithApplianceShape, WallItemShape {
  readonly id: DomainEntityId<'BurnerBaseW24'>
  readonly type: 'BurnerBaseW24'
}
export const BurnerBaseW24: DomainEntityReflection<BurnerBaseW24> = new DomainEntityReflection<BurnerBaseW24>(
  'BurnerBaseW24',
  [AdjustableDoorCabinetShape._meta.schema, BottomCabinetWithApplianceShape._meta.schema, WallItemShape._meta.schema]
)

export interface LoweredBurnerBaseW24
  extends AdjustableDoorCabinetShape,
    BottomCabinetWithApplianceShape,
    WallItemShape {
  readonly id: DomainEntityId<'LoweredBurnerBaseW24'>
  readonly type: 'LoweredBurnerBaseW24'
}
export const LoweredBurnerBaseW24: DomainEntityReflection<LoweredBurnerBaseW24> =
  new DomainEntityReflection<LoweredBurnerBaseW24>('LoweredBurnerBaseW24', [
    AdjustableDoorCabinetShape._meta.schema,
    BottomCabinetWithApplianceShape._meta.schema,
    WallItemShape._meta.schema,
  ])

export interface CornerFiller extends CornerFillerShape {
  readonly id: DomainEntityId<'CornerFiller'>
  readonly type: 'CornerFiller'
}
export const CornerFiller: DomainEntityReflection<CornerFiller> = new DomainEntityReflection<CornerFiller>(
  'CornerFiller',
  [CornerFillerShape._meta.schema]
)

export interface Drawer33Door66 extends Drawer33Door66Shape, AdjustableDoorCabinetShape, WallItemShape {
  readonly id: DomainEntityId<'Drawer33Door66'>
  readonly type: 'Drawer33Door66'
}
export const Drawer33Door66: DomainEntityReflection<Drawer33Door66> = new DomainEntityReflection<Drawer33Door66>(
  'Drawer33Door66',
  [Drawer33Door66Shape._meta.schema, AdjustableDoorCabinetShape._meta.schema, WallItemShape._meta.schema]
)

export interface EvoBaseW36 extends AdjustableDoorCabinetShape, BottomCabinetWithApplianceShape, WallItemShape {
  readonly id: DomainEntityId<'EvoBaseW36'>
  readonly type: 'EvoBaseW36'
}
export const EvoBaseW36: DomainEntityReflection<EvoBaseW36> = new DomainEntityReflection<EvoBaseW36>('EvoBaseW36', [
  AdjustableDoorCabinetShape._meta.schema,
  BottomCabinetWithApplianceShape._meta.schema,
  WallItemShape._meta.schema,
])

export interface EvoAffinity25G {
  readonly id: DomainEntityId<'EvoAffinity25G'>
  readonly type: 'EvoAffinity25G'
}
export const EvoAffinity25G: DomainEntityReflection<EvoAffinity25G> = new DomainEntityReflection<EvoAffinity25G>(
  'EvoAffinity25G',
  []
)

export interface EvoAffinity30G {
  readonly id: DomainEntityId<'EvoAffinity30G'>
  readonly type: 'EvoAffinity30G'
}
export const EvoAffinity30G: DomainEntityReflection<EvoAffinity30G> = new DomainEntityReflection<EvoAffinity30G>(
  'EvoAffinity30G',
  []
)

export interface EndPanel extends WallItemShape {
  readonly id: DomainEntityId<'EndPanel'>
  readonly type: 'EndPanel'
}
export const EndPanel: DomainEntityReflection<EndPanel> = new DomainEntityReflection<EndPanel>('EndPanel', [
  WallItemShape._meta.schema,
])

export interface Filler extends FillerShape, WallItemShape {
  readonly id: DomainEntityId<'Filler'>
  readonly type: 'Filler'
}
export const Filler: DomainEntityReflection<Filler> = new DomainEntityReflection<Filler>('Filler', [
  FillerShape._meta.schema,
  WallItemShape._meta.schema,
])

export interface FullDoorBase
  extends FullDoorBaseShape,
    AdjustableDoorCabinetShape,
    BottomCabinetWithApplianceShape,
    WallItemShape {
  readonly id: DomainEntityId<'FullDoorBase'>
  readonly type: 'FullDoorBase'
}
export const FullDoorBase: DomainEntityReflection<FullDoorBase> = new DomainEntityReflection<FullDoorBase>(
  'FullDoorBase',
  [
    FullDoorBaseShape._meta.schema,
    AdjustableDoorCabinetShape._meta.schema,
    BottomCabinetWithApplianceShape._meta.schema,
    WallItemShape._meta.schema,
  ]
)

export interface GrillBase
  extends GrillBaseShape,
    AdjustableDoorCabinetShape,
    BottomCabinetWithApplianceShape,
    WallItemShape {
  readonly id: DomainEntityId<'GrillBase'>
  readonly type: 'GrillBase'
}
export const GrillBase: DomainEntityReflection<GrillBase> = new DomainEntityReflection<GrillBase>('GrillBase', [
  GrillBaseShape._meta.schema,
  AdjustableDoorCabinetShape._meta.schema,
  BottomCabinetWithApplianceShape._meta.schema,
  WallItemShape._meta.schema,
])

export interface KamadoGrillBase extends AdjustableDoorCabinetShape, BottomCabinetWithApplianceShape, WallItemShape {
  readonly id: DomainEntityId<'KamadoGrillBase'>
  readonly type: 'KamadoGrillBase'
}
export const KamadoGrillBase: DomainEntityReflection<KamadoGrillBase> = new DomainEntityReflection<KamadoGrillBase>(
  'KamadoGrillBase',
  [AdjustableDoorCabinetShape._meta.schema, BottomCabinetWithApplianceShape._meta.schema, WallItemShape._meta.schema]
)

export interface LynxAsadoGriddgle extends ApplianceWithPowderCoatingShape {
  readonly id: DomainEntityId<'LynxAsadoGriddgle'>
  readonly type: 'LynxAsadoGriddgle'
}
export const LynxAsadoGriddgle: DomainEntityReflection<LynxAsadoGriddgle> =
  new DomainEntityReflection<LynxAsadoGriddgle>('LynxAsadoGriddgle', [ApplianceWithPowderCoatingShape._meta.schema])

export interface LynxKamadoGrill {
  readonly id: DomainEntityId<'LynxKamadoGrill'>
  readonly type: 'LynxKamadoGrill'
}
export const LynxKamadoGrill: DomainEntityReflection<LynxKamadoGrill> = new DomainEntityReflection<LynxKamadoGrill>(
  'LynxKamadoGrill',
  []
)

export interface LynxProfessionalCocktailStation {
  readonly id: DomainEntityId<'LynxProfessionalCocktailStation'>
  readonly type: 'LynxProfessionalCocktailStation'
}
export const LynxProfessionalCocktailStation: DomainEntityReflection<LynxProfessionalCocktailStation> =
  new DomainEntityReflection<LynxProfessionalCocktailStation>('LynxProfessionalCocktailStation', [])

export interface LynxProfessionalGrillW30 extends LynxGrillShape, ApplianceWithPowderCoatingShape {
  readonly id: DomainEntityId<'LynxProfessionalGrillW30'>
  readonly type: 'LynxProfessionalGrillW30'
}
export const LynxProfessionalGrillW30: DomainEntityReflection<LynxProfessionalGrillW30> =
  new DomainEntityReflection<LynxProfessionalGrillW30>('LynxProfessionalGrillW30', [
    LynxGrillShape._meta.schema,
    ApplianceWithPowderCoatingShape._meta.schema,
  ])

export interface LynxProfessionalGrillW36 extends LynxGrillShape, ApplianceWithPowderCoatingShape {
  readonly id: DomainEntityId<'LynxProfessionalGrillW36'>
  readonly type: 'LynxProfessionalGrillW36'
}
export const LynxProfessionalGrillW36: DomainEntityReflection<LynxProfessionalGrillW36> =
  new DomainEntityReflection<LynxProfessionalGrillW36>('LynxProfessionalGrillW36', [
    LynxGrillShape._meta.schema,
    ApplianceWithPowderCoatingShape._meta.schema,
  ])

export interface LynxProfessionalGrillW42 extends LynxGrillShape, ApplianceWithPowderCoatingShape {
  readonly id: DomainEntityId<'LynxProfessionalGrillW42'>
  readonly type: 'LynxProfessionalGrillW42'
}
export const LynxProfessionalGrillW42: DomainEntityReflection<LynxProfessionalGrillW42> =
  new DomainEntityReflection<LynxProfessionalGrillW42>('LynxProfessionalGrillW42', [
    LynxGrillShape._meta.schema,
    ApplianceWithPowderCoatingShape._meta.schema,
  ])

export interface LynxProfessionalGrillW54 extends LynxGrillShape, ApplianceWithPowderCoatingShape {
  readonly id: DomainEntityId<'LynxProfessionalGrillW54'>
  readonly type: 'LynxProfessionalGrillW54'
}
export const LynxProfessionalGrillW54: DomainEntityReflection<LynxProfessionalGrillW54> =
  new DomainEntityReflection<LynxProfessionalGrillW54>('LynxProfessionalGrillW54', [
    LynxGrillShape._meta.schema,
    ApplianceWithPowderCoatingShape._meta.schema,
  ])

export interface LynxProfessionalSingleBurner extends ApplianceWithPowderCoatingShape {
  readonly id: DomainEntityId<'LynxProfessionalSingleBurner'>
  readonly type: 'LynxProfessionalSingleBurner'
}
export const LynxProfessionalSingleBurner: DomainEntityReflection<LynxProfessionalSingleBurner> =
  new DomainEntityReflection<LynxProfessionalSingleBurner>('LynxProfessionalSingleBurner', [
    ApplianceWithPowderCoatingShape._meta.schema,
  ])

export interface LynxProfessionalDoubleBurner extends ApplianceWithPowderCoatingShape {
  readonly id: DomainEntityId<'LynxProfessionalDoubleBurner'>
  readonly type: 'LynxProfessionalDoubleBurner'
}
export const LynxProfessionalDoubleBurner: DomainEntityReflection<LynxProfessionalDoubleBurner> =
  new DomainEntityReflection<LynxProfessionalDoubleBurner>('LynxProfessionalDoubleBurner', [
    ApplianceWithPowderCoatingShape._meta.schema,
  ])

export interface LynxProfessionalPowerBurner extends ApplianceWithPowderCoatingShape {
  readonly id: DomainEntityId<'LynxProfessionalPowerBurner'>
  readonly type: 'LynxProfessionalPowerBurner'
}
export const LynxProfessionalPowerBurner: DomainEntityReflection<LynxProfessionalPowerBurner> =
  new DomainEntityReflection<LynxProfessionalPowerBurner>('LynxProfessionalPowerBurner', [
    ApplianceWithPowderCoatingShape._meta.schema,
  ])

export interface LynxProfessionalOutdoorBeverageDispenserW24
  extends LynxProfessionalOutdoorBeverageDispenserW24Shape,
    BottomAdjustableDoorApplianceShape,
    WallItemShape {
  readonly id: DomainEntityId<'LynxProfessionalOutdoorBeverageDispenserW24'>
  readonly type: 'LynxProfessionalOutdoorBeverageDispenserW24'
}
export const LynxProfessionalOutdoorBeverageDispenserW24: DomainEntityReflection<LynxProfessionalOutdoorBeverageDispenserW24> =
  new DomainEntityReflection<LynxProfessionalOutdoorBeverageDispenserW24>(
    'LynxProfessionalOutdoorBeverageDispenserW24',
    [
      LynxProfessionalOutdoorBeverageDispenserW24Shape._meta.schema,
      BottomAdjustableDoorApplianceShape._meta.schema,
      WallItemShape._meta.schema,
    ]
  )

export interface LynxProfessionalRefrigeratorFreezerComboW24 extends BottomAdjustableDoorApplianceShape, WallItemShape {
  readonly id: DomainEntityId<'LynxProfessionalRefrigeratorFreezerComboW24'>
  readonly type: 'LynxProfessionalRefrigeratorFreezerComboW24'
}
export const LynxProfessionalRefrigeratorFreezerComboW24: DomainEntityReflection<LynxProfessionalRefrigeratorFreezerComboW24> =
  new DomainEntityReflection<LynxProfessionalRefrigeratorFreezerComboW24>(
    'LynxProfessionalRefrigeratorFreezerComboW24',
    [BottomAdjustableDoorApplianceShape._meta.schema, WallItemShape._meta.schema]
  )

export interface LynxProfessionalOutdoorRefrigeratorW24 extends BottomAdjustableDoorApplianceShape, WallItemShape {
  readonly id: DomainEntityId<'LynxProfessionalOutdoorRefrigeratorW24'>
  readonly type: 'LynxProfessionalOutdoorRefrigeratorW24'
}
export const LynxProfessionalOutdoorRefrigeratorW24: DomainEntityReflection<LynxProfessionalOutdoorRefrigeratorW24> =
  new DomainEntityReflection<LynxProfessionalOutdoorRefrigeratorW24>('LynxProfessionalOutdoorRefrigeratorW24', [
    BottomAdjustableDoorApplianceShape._meta.schema,
    WallItemShape._meta.schema,
  ])

export interface LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24
  extends BottomAdjustableDoorApplianceShape,
    WallItemShape {
  readonly id: DomainEntityId<'LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24'>
  readonly type: 'LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24'
}
export const LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24: DomainEntityReflection<LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24> =
  new DomainEntityReflection<LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24>(
    'LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24',
    [BottomAdjustableDoorApplianceShape._meta.schema, WallItemShape._meta.schema]
  )

export interface LynxProfessionalRefrigeratorW15 extends BottomAdjustableDoorApplianceShape, WallItemShape {
  readonly id: DomainEntityId<'LynxProfessionalRefrigeratorW15'>
  readonly type: 'LynxProfessionalRefrigeratorW15'
}
export const LynxProfessionalRefrigeratorW15: DomainEntityReflection<LynxProfessionalRefrigeratorW15> =
  new DomainEntityReflection<LynxProfessionalRefrigeratorW15>('LynxProfessionalRefrigeratorW15', [
    BottomAdjustableDoorApplianceShape._meta.schema,
    WallItemShape._meta.schema,
  ])

export interface LynxProfessionalWineCellarW15 extends BottomAdjustableDoorApplianceShape, WallItemShape {
  readonly id: DomainEntityId<'LynxProfessionalWineCellarW15'>
  readonly type: 'LynxProfessionalWineCellarW15'
}
export const LynxProfessionalWineCellarW15: DomainEntityReflection<LynxProfessionalWineCellarW15> =
  new DomainEntityReflection<LynxProfessionalWineCellarW15>('LynxProfessionalWineCellarW15', [
    BottomAdjustableDoorApplianceShape._meta.schema,
    WallItemShape._meta.schema,
  ])

export interface LynxProfessionalTwoDrawerRefrigeratorW24 extends WallItemShape {
  readonly id: DomainEntityId<'LynxProfessionalTwoDrawerRefrigeratorW24'>
  readonly type: 'LynxProfessionalTwoDrawerRefrigeratorW24'
}
export const LynxProfessionalTwoDrawerRefrigeratorW24: DomainEntityReflection<LynxProfessionalTwoDrawerRefrigeratorW24> =
  new DomainEntityReflection<LynxProfessionalTwoDrawerRefrigeratorW24>('LynxProfessionalTwoDrawerRefrigeratorW24', [
    WallItemShape._meta.schema,
  ])

export interface LynxProfessionalOutdoorIceMachineW15
  extends LynxProfessionalOutdoorIceMachineW15Shape,
    BottomAdjustableDoorApplianceShape,
    WallItemShape {
  readonly id: DomainEntityId<'LynxProfessionalOutdoorIceMachineW15'>
  readonly type: 'LynxProfessionalOutdoorIceMachineW15'
}
export const LynxProfessionalOutdoorIceMachineW15: DomainEntityReflection<LynxProfessionalOutdoorIceMachineW15> =
  new DomainEntityReflection<LynxProfessionalOutdoorIceMachineW15>('LynxProfessionalOutdoorIceMachineW15', [
    LynxProfessionalOutdoorIceMachineW15Shape._meta.schema,
    BottomAdjustableDoorApplianceShape._meta.schema,
    WallItemShape._meta.schema,
  ])

export interface LynxProfessionalOutdoorIceMachineDrainPump {
  readonly id: DomainEntityId<'LynxProfessionalOutdoorIceMachineDrainPump'>
  readonly type: 'LynxProfessionalOutdoorIceMachineDrainPump'
}
export const LynxProfessionalOutdoorIceMachineDrainPump: DomainEntityReflection<LynxProfessionalOutdoorIceMachineDrainPump> =
  new DomainEntityReflection<LynxProfessionalOutdoorIceMachineDrainPump>(
    'LynxProfessionalOutdoorIceMachineDrainPump',
    []
  )

export interface LynxProfessionalSingleTapTowerKit {
  readonly id: DomainEntityId<'LynxProfessionalSingleTapTowerKit'>
  readonly type: 'LynxProfessionalSingleTapTowerKit'
}
export const LynxProfessionalSingleTapTowerKit: DomainEntityReflection<LynxProfessionalSingleTapTowerKit> =
  new DomainEntityReflection<LynxProfessionalSingleTapTowerKit>('LynxProfessionalSingleTapTowerKit', [])

export interface LynxProfessionalDoubleTapTowerKit {
  readonly id: DomainEntityId<'LynxProfessionalDoubleTapTowerKit'>
  readonly type: 'LynxProfessionalDoubleTapTowerKit'
}
export const LynxProfessionalDoubleTapTowerKit: DomainEntityReflection<LynxProfessionalDoubleTapTowerKit> =
  new DomainEntityReflection<LynxProfessionalDoubleTapTowerKit>('LynxProfessionalDoubleTapTowerKit', [])

export interface LynxSedonaGrillW30 extends LynxGrillShape, ApplianceWithPowderCoatingShape {
  readonly id: DomainEntityId<'LynxSedonaGrillW30'>
  readonly type: 'LynxSedonaGrillW30'
}
export const LynxSedonaGrillW30: DomainEntityReflection<LynxSedonaGrillW30> =
  new DomainEntityReflection<LynxSedonaGrillW30>('LynxSedonaGrillW30', [
    LynxGrillShape._meta.schema,
    ApplianceWithPowderCoatingShape._meta.schema,
  ])

export interface LynxSedonaGrillW36 extends LynxGrillShape, ApplianceWithPowderCoatingShape {
  readonly id: DomainEntityId<'LynxSedonaGrillW36'>
  readonly type: 'LynxSedonaGrillW36'
}
export const LynxSedonaGrillW36: DomainEntityReflection<LynxSedonaGrillW36> =
  new DomainEntityReflection<LynxSedonaGrillW36>('LynxSedonaGrillW36', [
    LynxGrillShape._meta.schema,
    ApplianceWithPowderCoatingShape._meta.schema,
  ])

export interface LynxSedonaGrillW42 extends LynxGrillShape, ApplianceWithPowderCoatingShape {
  readonly id: DomainEntityId<'LynxSedonaGrillW42'>
  readonly type: 'LynxSedonaGrillW42'
}
export const LynxSedonaGrillW42: DomainEntityReflection<LynxSedonaGrillW42> =
  new DomainEntityReflection<LynxSedonaGrillW42>('LynxSedonaGrillW42', [
    LynxGrillShape._meta.schema,
    ApplianceWithPowderCoatingShape._meta.schema,
  ])

export interface LynxSedonaSingleBurner extends ApplianceWithPowderCoatingShape {
  readonly id: DomainEntityId<'LynxSedonaSingleBurner'>
  readonly type: 'LynxSedonaSingleBurner'
}
export const LynxSedonaSingleBurner: DomainEntityReflection<LynxSedonaSingleBurner> =
  new DomainEntityReflection<LynxSedonaSingleBurner>('LynxSedonaSingleBurner', [
    ApplianceWithPowderCoatingShape._meta.schema,
  ])

export interface LynxSedonaDoubleBurner extends ApplianceWithPowderCoatingShape {
  readonly id: DomainEntityId<'LynxSedonaDoubleBurner'>
  readonly type: 'LynxSedonaDoubleBurner'
}
export const LynxSedonaDoubleBurner: DomainEntityReflection<LynxSedonaDoubleBurner> =
  new DomainEntityReflection<LynxSedonaDoubleBurner>('LynxSedonaDoubleBurner', [
    ApplianceWithPowderCoatingShape._meta.schema,
  ])

export interface LynxSedonaHoodW36 extends WallItemShape {
  readonly id: DomainEntityId<'LynxSedonaHoodW36'>
  readonly type: 'LynxSedonaHoodW36'
}
export const LynxSedonaHoodW36: DomainEntityReflection<LynxSedonaHoodW36> =
  new DomainEntityReflection<LynxSedonaHoodW36>('LynxSedonaHoodW36', [WallItemShape._meta.schema])

export interface LynxSedonaHoodW42 extends WallItemShape {
  readonly id: DomainEntityId<'LynxSedonaHoodW42'>
  readonly type: 'LynxSedonaHoodW42'
}
export const LynxSedonaHoodW42: DomainEntityReflection<LynxSedonaHoodW42> =
  new DomainEntityReflection<LynxSedonaHoodW42>('LynxSedonaHoodW42', [WallItemShape._meta.schema])

export interface LynxSedonaHoodW48 extends WallItemShape {
  readonly id: DomainEntityId<'LynxSedonaHoodW48'>
  readonly type: 'LynxSedonaHoodW48'
}
export const LynxSedonaHoodW48: DomainEntityReflection<LynxSedonaHoodW48> =
  new DomainEntityReflection<LynxSedonaHoodW48>('LynxSedonaHoodW48', [WallItemShape._meta.schema])

export interface LynxSinkW18 extends LynxSinkShape {
  readonly id: DomainEntityId<'LynxSinkW18'>
  readonly type: 'LynxSinkW18'
}
export const LynxSinkW18: DomainEntityReflection<LynxSinkW18> = new DomainEntityReflection<LynxSinkW18>('LynxSinkW18', [
  LynxSinkShape._meta.schema,
])

export interface LynxSinkW24 extends LynxSinkShape {
  readonly id: DomainEntityId<'LynxSinkW24'>
  readonly type: 'LynxSinkW24'
}
export const LynxSinkW24: DomainEntityReflection<LynxSinkW24> = new DomainEntityReflection<LynxSinkW24>('LynxSinkW24', [
  LynxSinkShape._meta.schema,
])

export interface LynxSinkW30 extends LynxSinkShape {
  readonly id: DomainEntityId<'LynxSinkW30'>
  readonly type: 'LynxSinkW30'
}
export const LynxSinkW30: DomainEntityReflection<LynxSinkW30> = new DomainEntityReflection<LynxSinkW30>('LynxSinkW30', [
  LynxSinkShape._meta.schema,
])

export interface LynxWarmingDrawer extends ApplianceWithPowderCoatingShape {
  readonly id: DomainEntityId<'LynxWarmingDrawer'>
  readonly type: 'LynxWarmingDrawer'
}
export const LynxWarmingDrawer: DomainEntityReflection<LynxWarmingDrawer> =
  new DomainEntityReflection<LynxWarmingDrawer>('LynxWarmingDrawer', [ApplianceWithPowderCoatingShape._meta.schema])

export interface Room extends RoomShape {
  readonly id: DomainEntityId<'Room'>
  readonly type: 'Room'
}
export const Room: DomainEntityReflection<Room> = new DomainEntityReflection<Room>('Room', [RoomShape._meta.schema])

export interface RearPanel extends RearPanelShape {
  readonly id: DomainEntityId<'RearPanel'>
  readonly type: 'RearPanel'
}
export const RearPanel: DomainEntityReflection<RearPanel> = new DomainEntityReflection<RearPanel>('RearPanel', [
  RearPanelShape._meta.schema,
])

export interface SinkBase
  extends SinkBaseShape,
    AdjustableDoorCabinetShape,
    BottomCabinetWithApplianceShape,
    WallItemShape {
  readonly id: DomainEntityId<'SinkBase'>
  readonly type: 'SinkBase'
}
export const SinkBase: DomainEntityReflection<SinkBase> = new DomainEntityReflection<SinkBase>('SinkBase', [
  SinkBaseShape._meta.schema,
  AdjustableDoorCabinetShape._meta.schema,
  BottomCabinetWithApplianceShape._meta.schema,
  WallItemShape._meta.schema,
])

export interface ThreeDrawerBase extends ThreeDrawerBaseShape, WallItemShape {
  readonly id: DomainEntityId<'ThreeDrawerBase'>
  readonly type: 'ThreeDrawerBase'
}
export const ThreeDrawerBase: DomainEntityReflection<ThreeDrawerBase> = new DomainEntityReflection<ThreeDrawerBase>(
  'ThreeDrawerBase',
  [ThreeDrawerBaseShape._meta.schema, WallItemShape._meta.schema]
)

export interface TrashPulloutBase extends TrashPulloutBaseShape, AdjustableDoorCabinetShape, WallItemShape {
  readonly id: DomainEntityId<'TrashPulloutBase'>
  readonly type: 'TrashPulloutBase'
}
export const TrashPulloutBase: DomainEntityReflection<TrashPulloutBase> = new DomainEntityReflection<TrashPulloutBase>(
  'TrashPulloutBase',
  [TrashPulloutBaseShape._meta.schema, AdjustableDoorCabinetShape._meta.schema, WallItemShape._meta.schema]
)

export interface Wall extends WallShape {
  readonly id: DomainEntityId<'Wall'>
  readonly type: 'Wall'
}
export const Wall: DomainEntityReflection<Wall> = new DomainEntityReflection<Wall>('Wall', [WallShape._meta.schema])

export type AnyDomainEntity =
  | BurnerBaseW18
  | BurnerBaseW24
  | LoweredBurnerBaseW24
  | CornerFiller
  | Drawer33Door66
  | EvoBaseW36
  | EvoAffinity25G
  | EvoAffinity30G
  | EndPanel
  | Filler
  | FullDoorBase
  | GrillBase
  | KamadoGrillBase
  | LynxAsadoGriddgle
  | LynxKamadoGrill
  | LynxProfessionalCocktailStation
  | LynxProfessionalGrillW30
  | LynxProfessionalGrillW36
  | LynxProfessionalGrillW42
  | LynxProfessionalGrillW54
  | LynxProfessionalSingleBurner
  | LynxProfessionalDoubleBurner
  | LynxProfessionalPowerBurner
  | LynxProfessionalOutdoorBeverageDispenserW24
  | LynxProfessionalRefrigeratorFreezerComboW24
  | LynxProfessionalOutdoorRefrigeratorW24
  | LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24
  | LynxProfessionalRefrigeratorW15
  | LynxProfessionalWineCellarW15
  | LynxProfessionalTwoDrawerRefrigeratorW24
  | LynxProfessionalOutdoorIceMachineW15
  | LynxProfessionalOutdoorIceMachineDrainPump
  | LynxProfessionalSingleTapTowerKit
  | LynxProfessionalDoubleTapTowerKit
  | LynxSedonaGrillW30
  | LynxSedonaGrillW36
  | LynxSedonaGrillW42
  | LynxSedonaSingleBurner
  | LynxSedonaDoubleBurner
  | LynxSedonaHoodW36
  | LynxSedonaHoodW42
  | LynxSedonaHoodW48
  | LynxSinkW18
  | LynxSinkW24
  | LynxSinkW30
  | LynxWarmingDrawer
  | Room
  | RearPanel
  | SinkBase
  | ThreeDrawerBase
  | TrashPulloutBase
  | Wall
export const AnyDomainEntity: RawAliasReflection<AnyDomainEntity> = new RawAliasReflection<AnyDomainEntity>(
  'AnyDomainEntity',
  [
    BurnerBaseW18,
    BurnerBaseW24,
    LoweredBurnerBaseW24,
    CornerFiller,
    Drawer33Door66,
    EvoBaseW36,
    EvoAffinity25G,
    EvoAffinity30G,
    EndPanel,
    Filler,
    FullDoorBase,
    GrillBase,
    KamadoGrillBase,
    LynxAsadoGriddgle,
    LynxKamadoGrill,
    LynxProfessionalCocktailStation,
    LynxProfessionalGrillW30,
    LynxProfessionalGrillW36,
    LynxProfessionalGrillW42,
    LynxProfessionalGrillW54,
    LynxProfessionalSingleBurner,
    LynxProfessionalDoubleBurner,
    LynxProfessionalPowerBurner,
    LynxProfessionalOutdoorBeverageDispenserW24,
    LynxProfessionalRefrigeratorFreezerComboW24,
    LynxProfessionalOutdoorRefrigeratorW24,
    LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24,
    LynxProfessionalRefrigeratorW15,
    LynxProfessionalWineCellarW15,
    LynxProfessionalTwoDrawerRefrigeratorW24,
    LynxProfessionalOutdoorIceMachineW15,
    LynxProfessionalOutdoorIceMachineDrainPump,
    LynxProfessionalSingleTapTowerKit,
    LynxProfessionalDoubleTapTowerKit,
    LynxSedonaGrillW30,
    LynxSedonaGrillW36,
    LynxSedonaGrillW42,
    LynxSedonaSingleBurner,
    LynxSedonaDoubleBurner,
    LynxSedonaHoodW36,
    LynxSedonaHoodW42,
    LynxSedonaHoodW48,
    LynxSinkW18,
    LynxSinkW24,
    LynxSinkW30,
    LynxWarmingDrawer,
    Room,
    RearPanel,
    SinkBase,
    ThreeDrawerBase,
    TrashPulloutBase,
    Wall,
  ]
)

export type RootEntity = Room
export const RootEntity: RawAliasReflection<RootEntity> = new RawAliasReflection<RootEntity>('RootEntity', [Room])

export type StaticEntity = Room | Wall | CornerFiller
export const StaticEntity: RawAliasReflection<StaticEntity> = new RawAliasReflection<StaticEntity>('StaticEntity', [
  Room,
  Wall,
  CornerFiller,
])

export type BurnerBase = BurnerBaseW18 | BurnerBaseW24 | LoweredBurnerBaseW24
export const BurnerBase: RawAliasReflection<BurnerBase> = new RawAliasReflection<BurnerBase>('BurnerBase', [
  BurnerBaseW18,
  BurnerBaseW24,
  LoweredBurnerBaseW24,
])

export type AdjustableDoorCabinet =
  | BurnerBase
  | Drawer33Door66
  | EvoBaseW36
  | FullDoorBase
  | GrillBase
  | KamadoGrillBase
  | SinkBase
  | TrashPulloutBase
export const AdjustableDoorCabinet: RawAliasReflection<AdjustableDoorCabinet> =
  new RawAliasReflection<AdjustableDoorCabinet>('AdjustableDoorCabinet', [
    ...BurnerBase.reflections,
    Drawer33Door66,
    EvoBaseW36,
    FullDoorBase,
    GrillBase,
    KamadoGrillBase,
    SinkBase,
    TrashPulloutBase,
  ])

export type TopAppliance = LynxSedonaHoodW36 | LynxSedonaHoodW42 | LynxSedonaHoodW48
export const TopAppliance: RawAliasReflection<TopAppliance> = new RawAliasReflection<TopAppliance>('TopAppliance', [
  LynxSedonaHoodW36,
  LynxSedonaHoodW42,
  LynxSedonaHoodW48,
])

export type LynxSink = LynxSinkW18 | LynxSinkW24 | LynxSinkW30
export const LynxSink: RawAliasReflection<LynxSink> = new RawAliasReflection<LynxSink>('LynxSink', [
  LynxSinkW18,
  LynxSinkW24,
  LynxSinkW30,
])

export type BottomAdjustableDoorAppliance =
  | LynxProfessionalOutdoorBeverageDispenserW24
  | LynxProfessionalRefrigeratorFreezerComboW24
  | LynxProfessionalOutdoorRefrigeratorW24
  | LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24
  | LynxProfessionalRefrigeratorW15
  | LynxProfessionalWineCellarW15
  | LynxProfessionalOutdoorIceMachineW15
export const BottomAdjustableDoorAppliance: RawAliasReflection<BottomAdjustableDoorAppliance> =
  new RawAliasReflection<BottomAdjustableDoorAppliance>('BottomAdjustableDoorAppliance', [
    LynxProfessionalOutdoorBeverageDispenserW24,
    LynxProfessionalRefrigeratorFreezerComboW24,
    LynxProfessionalOutdoorRefrigeratorW24,
    LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24,
    LynxProfessionalRefrigeratorW15,
    LynxProfessionalWineCellarW15,
    LynxProfessionalOutdoorIceMachineW15,
  ])

export type BottomNonAdjustableDoorAppliance =
  | LynxProfessionalTwoDrawerRefrigeratorW24
  | LynxProfessionalSingleTapTowerKit
  | LynxProfessionalDoubleTapTowerKit
  | LynxProfessionalOutdoorIceMachineDrainPump
  | LynxWarmingDrawer
export const BottomNonAdjustableDoorAppliance: RawAliasReflection<BottomNonAdjustableDoorAppliance> =
  new RawAliasReflection<BottomNonAdjustableDoorAppliance>('BottomNonAdjustableDoorAppliance', [
    LynxProfessionalTwoDrawerRefrigeratorW24,
    LynxProfessionalSingleTapTowerKit,
    LynxProfessionalDoubleTapTowerKit,
    LynxProfessionalOutdoorIceMachineDrainPump,
    LynxWarmingDrawer,
  ])

export type BottomCabinetAppliance =
  | LynxAsadoGriddgle
  | LynxKamadoGrill
  | LynxProfessionalGrillW30
  | LynxProfessionalGrillW36
  | LynxProfessionalGrillW42
  | LynxProfessionalGrillW54
  | LynxSedonaGrillW30
  | LynxSedonaGrillW36
  | LynxSedonaGrillW42
  | LynxProfessionalCocktailStation
  | LynxProfessionalSingleBurner
  | LynxProfessionalDoubleBurner
  | LynxProfessionalPowerBurner
  | LynxSedonaSingleBurner
  | LynxSedonaDoubleBurner
  | LynxSinkW18
  | LynxSinkW24
  | LynxSinkW30
  | EvoAffinity25G
  | EvoAffinity30G
export const BottomCabinetAppliance: RawAliasReflection<BottomCabinetAppliance> =
  new RawAliasReflection<BottomCabinetAppliance>('BottomCabinetAppliance', [
    LynxAsadoGriddgle,
    LynxKamadoGrill,
    LynxProfessionalGrillW30,
    LynxProfessionalGrillW36,
    LynxProfessionalGrillW42,
    LynxProfessionalGrillW54,
    LynxSedonaGrillW30,
    LynxSedonaGrillW36,
    LynxSedonaGrillW42,
    LynxProfessionalCocktailStation,
    LynxProfessionalSingleBurner,
    LynxProfessionalDoubleBurner,
    LynxProfessionalPowerBurner,
    LynxSedonaSingleBurner,
    LynxSedonaDoubleBurner,
    LynxSinkW18,
    LynxSinkW24,
    LynxSinkW30,
    EvoAffinity25G,
    EvoAffinity30G,
  ])

export type BottomWallAppliance =
  | LynxProfessionalOutdoorBeverageDispenserW24
  | LynxProfessionalRefrigeratorFreezerComboW24
  | LynxProfessionalOutdoorRefrigeratorW24
  | LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24
  | LynxProfessionalRefrigeratorW15
  | LynxProfessionalWineCellarW15
  | LynxProfessionalTwoDrawerRefrigeratorW24
  | LynxProfessionalOutdoorIceMachineW15
export const BottomWallAppliance: RawAliasReflection<BottomWallAppliance> = new RawAliasReflection<BottomWallAppliance>(
  'BottomWallAppliance',
  [
    LynxProfessionalOutdoorBeverageDispenserW24,
    LynxProfessionalRefrigeratorFreezerComboW24,
    LynxProfessionalOutdoorRefrigeratorW24,
    LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24,
    LynxProfessionalRefrigeratorW15,
    LynxProfessionalWineCellarW15,
    LynxProfessionalTwoDrawerRefrigeratorW24,
    LynxProfessionalOutdoorIceMachineW15,
  ]
)

export type BottomAppliance =
  | BottomCabinetAppliance
  | BottomWallAppliance
  | LynxProfessionalSingleTapTowerKit
  | LynxProfessionalDoubleTapTowerKit
  | LynxProfessionalOutdoorIceMachineDrainPump
  | LynxWarmingDrawer
export const BottomAppliance: RawAliasReflection<BottomAppliance> = new RawAliasReflection<BottomAppliance>(
  'BottomAppliance',
  [
    ...BottomCabinetAppliance.reflections,
    ...BottomWallAppliance.reflections,
    LynxProfessionalSingleTapTowerKit,
    LynxProfessionalDoubleTapTowerKit,
    LynxProfessionalOutdoorIceMachineDrainPump,
    LynxWarmingDrawer,
  ]
)

export type SwatchPowderCoatableRoomItem =
  | BurnerBase
  | CornerFiller
  | Drawer33Door66
  | EvoBaseW36
  | EndPanel
  | Filler
  | FullDoorBase
  | GrillBase
  | KamadoGrillBase
  | RearPanel
  | SinkBase
  | ThreeDrawerBase
  | TrashPulloutBase
export const SwatchPowderCoatableRoomItem: RawAliasReflection<SwatchPowderCoatableRoomItem> =
  new RawAliasReflection<SwatchPowderCoatableRoomItem>('SwatchPowderCoatableRoomItem', [
    ...BurnerBase.reflections,
    CornerFiller,
    Drawer33Door66,
    EvoBaseW36,
    EndPanel,
    Filler,
    FullDoorBase,
    GrillBase,
    KamadoGrillBase,
    RearPanel,
    SinkBase,
    ThreeDrawerBase,
    TrashPulloutBase,
  ])

export type PulsePowderCoatableRoomItem =
  | BurnerBase
  | Drawer33Door66
  | EvoBaseW36
  | FullDoorBase
  | GrillBase
  | KamadoGrillBase
  | SinkBase
  | ThreeDrawerBase
  | TrashPulloutBase
export const PulsePowderCoatableRoomItem: RawAliasReflection<PulsePowderCoatableRoomItem> =
  new RawAliasReflection<PulsePowderCoatableRoomItem>('PulsePowderCoatableRoomItem', [
    ...BurnerBase.reflections,
    Drawer33Door66,
    EvoBaseW36,
    FullDoorBase,
    GrillBase,
    KamadoGrillBase,
    SinkBase,
    ThreeDrawerBase,
    TrashPulloutBase,
  ])

export type BottomCabinet =
  | BurnerBase
  | Drawer33Door66
  | EvoBaseW36
  | FullDoorBase
  | GrillBase
  | KamadoGrillBase
  | SinkBase
  | ThreeDrawerBase
  | TrashPulloutBase
export const BottomCabinet: RawAliasReflection<BottomCabinet> = new RawAliasReflection<BottomCabinet>('BottomCabinet', [
  ...BurnerBase.reflections,
  Drawer33Door66,
  EvoBaseW36,
  FullDoorBase,
  GrillBase,
  KamadoGrillBase,
  SinkBase,
  ThreeDrawerBase,
  TrashPulloutBase,
])

export type BottomCabinetWithAppliance = BurnerBase | EvoBaseW36 | GrillBase | KamadoGrillBase | SinkBase | FullDoorBase
export const BottomCabinetWithAppliance: RawAliasReflection<BottomCabinetWithAppliance> =
  new RawAliasReflection<BottomCabinetWithAppliance>('BottomCabinetWithAppliance', [
    ...BurnerBase.reflections,
    EvoBaseW36,
    GrillBase,
    KamadoGrillBase,
    SinkBase,
    FullDoorBase,
  ])

export type BottomCabinetWithoutAppliance = Drawer33Door66 | ThreeDrawerBase | TrashPulloutBase
export const BottomCabinetWithoutAppliance: RawAliasReflection<BottomCabinetWithoutAppliance> =
  new RawAliasReflection<BottomCabinetWithoutAppliance>('BottomCabinetWithoutAppliance', [
    Drawer33Door66,
    ThreeDrawerBase,
    TrashPulloutBase,
  ])

export type BottomCabinetWithDefaultDetail =
  | BurnerBase
  | EvoBaseW36
  | Drawer33Door66
  | FullDoorBase
  | KamadoGrillBase
  | SinkBase
  | ThreeDrawerBase
  | TrashPulloutBase
export const BottomCabinetWithDefaultDetail: RawAliasReflection<BottomCabinetWithDefaultDetail> =
  new RawAliasReflection<BottomCabinetWithDefaultDetail>('BottomCabinetWithDefaultDetail', [
    ...BurnerBase.reflections,
    EvoBaseW36,
    Drawer33Door66,
    FullDoorBase,
    KamadoGrillBase,
    SinkBase,
    ThreeDrawerBase,
    TrashPulloutBase,
  ])

export type BottomPart = EndPanel | Filler | RearPanel
export const BottomPart: RawAliasReflection<BottomPart> = new RawAliasReflection<BottomPart>('BottomPart', [
  EndPanel,
  Filler,
  RearPanel,
])

export type BottomWallItemWithDefaultCountertop =
  | Drawer33Door66
  | EndPanel
  | Filler
  | LynxProfessionalOutdoorBeverageDispenserW24
  | LynxProfessionalRefrigeratorFreezerComboW24
  | LynxProfessionalOutdoorRefrigeratorW24
  | LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24
  | LynxProfessionalRefrigeratorW15
  | LynxProfessionalWineCellarW15
  | LynxProfessionalTwoDrawerRefrigeratorW24
  | LynxProfessionalOutdoorIceMachineW15
  | ThreeDrawerBase
  | TrashPulloutBase
export const BottomWallItemWithDefaultCountertop: RawAliasReflection<BottomWallItemWithDefaultCountertop> =
  new RawAliasReflection<BottomWallItemWithDefaultCountertop>('BottomWallItemWithDefaultCountertop', [
    Drawer33Door66,
    EndPanel,
    Filler,
    LynxProfessionalOutdoorBeverageDispenserW24,
    LynxProfessionalRefrigeratorFreezerComboW24,
    LynxProfessionalOutdoorRefrigeratorW24,
    LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24,
    LynxProfessionalRefrigeratorW15,
    LynxProfessionalWineCellarW15,
    LynxProfessionalTwoDrawerRefrigeratorW24,
    LynxProfessionalOutdoorIceMachineW15,
    ThreeDrawerBase,
    TrashPulloutBase,
  ])

export type BottomWallItemWithCustomCountertop =
  | BurnerBase
  | EvoBaseW36
  | FullDoorBase
  | GrillBase
  | KamadoGrillBase
  | SinkBase
export const BottomWallItemWithCustomCountertop: RawAliasReflection<BottomWallItemWithCustomCountertop> =
  new RawAliasReflection<BottomWallItemWithCustomCountertop>('BottomWallItemWithCustomCountertop', [
    ...BurnerBase.reflections,
    EvoBaseW36,
    FullDoorBase,
    GrillBase,
    KamadoGrillBase,
    SinkBase,
  ])

export type BottomWallItemWithDefaultToeKick =
  | BurnerBase
  | Drawer33Door66
  | EvoBaseW36
  | Filler
  | FullDoorBase
  | KamadoGrillBase
  | SinkBase
  | ThreeDrawerBase
  | TrashPulloutBase
export const BottomWallItemWithDefaultToeKick: RawAliasReflection<BottomWallItemWithDefaultToeKick> =
  new RawAliasReflection<BottomWallItemWithDefaultToeKick>('BottomWallItemWithDefaultToeKick', [
    ...BurnerBase.reflections,
    Drawer33Door66,
    EvoBaseW36,
    Filler,
    FullDoorBase,
    KamadoGrillBase,
    SinkBase,
    ThreeDrawerBase,
    TrashPulloutBase,
  ])

export type BottomWallItemWithCustomToeKick = GrillBase
export const BottomWallItemWithCustomToeKick: RawAliasReflection<BottomWallItemWithCustomToeKick> =
  new RawAliasReflection<BottomWallItemWithCustomToeKick>('BottomWallItemWithCustomToeKick', [GrillBase])

export type BottomWallItemWithBackPanel = BottomCabinet | BottomWallAppliance | Filler
export const BottomWallItemWithBackPanel: RawAliasReflection<BottomWallItemWithBackPanel> =
  new RawAliasReflection<BottomWallItemWithBackPanel>('BottomWallItemWithBackPanel', [
    ...BottomCabinet.reflections,
    ...BottomWallAppliance.reflections,
    Filler,
  ])

export type RoomItem = BottomAppliance | BottomCabinet | BottomPart | TopAppliance
export const RoomItem: RawAliasReflection<RoomItem> = new RawAliasReflection<RoomItem>('RoomItem', [
  ...BottomAppliance.reflections,
  ...BottomCabinet.reflections,
  ...BottomPart.reflections,
  ...TopAppliance.reflections,
])

export type RoomItemWithDefaultPrice =
  | BurnerBase
  | Drawer33Door66
  | EvoBaseW36
  | EvoAffinity25G
  | EvoAffinity30G
  | EndPanel
  | Filler
  | FullDoorBase
  | GrillBase
  | KamadoGrillBase
  | LynxKamadoGrill
  | LynxProfessionalCocktailStation
  | LynxProfessionalRefrigeratorFreezerComboW24
  | LynxProfessionalOutdoorRefrigeratorW24
  | LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24
  | LynxProfessionalRefrigeratorW15
  | LynxProfessionalWineCellarW15
  | LynxProfessionalOutdoorIceMachineW15
  | LynxProfessionalOutdoorBeverageDispenserW24
  | LynxProfessionalTwoDrawerRefrigeratorW24
  | LynxProfessionalOutdoorIceMachineDrainPump
  | LynxProfessionalSingleTapTowerKit
  | LynxProfessionalDoubleTapTowerKit
  | LynxSedonaHoodW36
  | LynxSedonaHoodW42
  | LynxSedonaHoodW48
  | LynxSinkW18
  | LynxSinkW24
  | LynxSinkW30
  | RearPanel
  | SinkBase
  | ThreeDrawerBase
  | TrashPulloutBase
export const RoomItemWithDefaultPrice: RawAliasReflection<RoomItemWithDefaultPrice> =
  new RawAliasReflection<RoomItemWithDefaultPrice>('RoomItemWithDefaultPrice', [
    ...BurnerBase.reflections,
    Drawer33Door66,
    EvoBaseW36,
    EvoAffinity25G,
    EvoAffinity30G,
    EndPanel,
    Filler,
    FullDoorBase,
    GrillBase,
    KamadoGrillBase,
    LynxKamadoGrill,
    LynxProfessionalCocktailStation,
    LynxProfessionalRefrigeratorFreezerComboW24,
    LynxProfessionalOutdoorRefrigeratorW24,
    LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24,
    LynxProfessionalRefrigeratorW15,
    LynxProfessionalWineCellarW15,
    LynxProfessionalOutdoorIceMachineW15,
    LynxProfessionalOutdoorBeverageDispenserW24,
    LynxProfessionalTwoDrawerRefrigeratorW24,
    LynxProfessionalOutdoorIceMachineDrainPump,
    LynxProfessionalSingleTapTowerKit,
    LynxProfessionalDoubleTapTowerKit,
    LynxSedonaHoodW36,
    LynxSedonaHoodW42,
    LynxSedonaHoodW48,
    LynxSinkW18,
    LynxSinkW24,
    LynxSinkW30,
    RearPanel,
    SinkBase,
    ThreeDrawerBase,
    TrashPulloutBase,
  ])

export type RoomItemWithDefaultSummary =
  | BurnerBase
  | Drawer33Door66
  | EvoBaseW36
  | EvoAffinity25G
  | EvoAffinity30G
  | EndPanel
  | Filler
  | FullDoorBase
  | GrillBase
  | KamadoGrillBase
  | LynxAsadoGriddgle
  | LynxKamadoGrill
  | LynxProfessionalCocktailStation
  | LynxProfessionalGrillW30
  | LynxProfessionalGrillW36
  | LynxProfessionalGrillW42
  | LynxProfessionalGrillW54
  | LynxProfessionalSingleBurner
  | LynxProfessionalDoubleBurner
  | LynxProfessionalPowerBurner
  | LynxProfessionalRefrigeratorFreezerComboW24
  | LynxProfessionalOutdoorRefrigeratorW24
  | LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24
  | LynxProfessionalRefrigeratorW15
  | LynxProfessionalWineCellarW15
  | LynxProfessionalTwoDrawerRefrigeratorW24
  | LynxProfessionalOutdoorIceMachineDrainPump
  | LynxProfessionalSingleTapTowerKit
  | LynxProfessionalDoubleTapTowerKit
  | LynxSedonaGrillW30
  | LynxSedonaGrillW36
  | LynxSedonaGrillW42
  | LynxSedonaSingleBurner
  | LynxSedonaDoubleBurner
  | LynxSedonaHoodW36
  | LynxSedonaHoodW42
  | LynxSedonaHoodW48
  | LynxWarmingDrawer
  | LynxSinkW18
  | LynxSinkW24
  | LynxSinkW30
  | RearPanel
  | SinkBase
  | ThreeDrawerBase
  | TrashPulloutBase
export const RoomItemWithDefaultSummary: RawAliasReflection<RoomItemWithDefaultSummary> =
  new RawAliasReflection<RoomItemWithDefaultSummary>('RoomItemWithDefaultSummary', [
    ...BurnerBase.reflections,
    Drawer33Door66,
    EvoBaseW36,
    EvoAffinity25G,
    EvoAffinity30G,
    EndPanel,
    Filler,
    FullDoorBase,
    GrillBase,
    KamadoGrillBase,
    LynxAsadoGriddgle,
    LynxKamadoGrill,
    LynxProfessionalCocktailStation,
    LynxProfessionalGrillW30,
    LynxProfessionalGrillW36,
    LynxProfessionalGrillW42,
    LynxProfessionalGrillW54,
    LynxProfessionalSingleBurner,
    LynxProfessionalDoubleBurner,
    LynxProfessionalPowerBurner,
    LynxProfessionalRefrigeratorFreezerComboW24,
    LynxProfessionalOutdoorRefrigeratorW24,
    LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24,
    LynxProfessionalRefrigeratorW15,
    LynxProfessionalWineCellarW15,
    LynxProfessionalTwoDrawerRefrigeratorW24,
    LynxProfessionalOutdoorIceMachineDrainPump,
    LynxProfessionalSingleTapTowerKit,
    LynxProfessionalDoubleTapTowerKit,
    LynxSedonaGrillW30,
    LynxSedonaGrillW36,
    LynxSedonaGrillW42,
    LynxSedonaSingleBurner,
    LynxSedonaDoubleBurner,
    LynxSedonaHoodW36,
    LynxSedonaHoodW42,
    LynxSedonaHoodW48,
    LynxWarmingDrawer,
    LynxSinkW18,
    LynxSinkW24,
    LynxSinkW30,
    RearPanel,
    SinkBase,
    ThreeDrawerBase,
    TrashPulloutBase,
  ])

export type BottomWallItem = BottomCabinet | BottomWallAppliance | Filler | EndPanel
export const BottomWallItem: RawAliasReflection<BottomWallItem> = new RawAliasReflection<BottomWallItem>(
  'BottomWallItem',
  [...BottomCabinet.reflections, ...BottomWallAppliance.reflections, Filler, EndPanel]
)

export type TopWallItem = TopAppliance
export const TopWallItem: RawAliasReflection<TopWallItem> = new RawAliasReflection<TopWallItem>('TopWallItem', [
  ...TopAppliance.reflections,
])

export type WallItem = BottomWallItem | TopWallItem
export const WallItem: RawAliasReflection<WallItem> = new RawAliasReflection<WallItem>('WallItem', [
  ...BottomWallItem.reflections,
  ...TopWallItem.reflections,
])

export type LynxProfessionalGrill =
  | LynxProfessionalGrillW30
  | LynxProfessionalGrillW36
  | LynxProfessionalGrillW42
  | LynxProfessionalGrillW54
export const LynxProfessionalGrill: RawAliasReflection<LynxProfessionalGrill> =
  new RawAliasReflection<LynxProfessionalGrill>('LynxProfessionalGrill', [
    LynxProfessionalGrillW30,
    LynxProfessionalGrillW36,
    LynxProfessionalGrillW42,
    LynxProfessionalGrillW54,
  ])

export type LynxSedonaGrill = LynxSedonaGrillW30 | LynxSedonaGrillW36 | LynxSedonaGrillW42
export const LynxSedonaGrill: RawAliasReflection<LynxSedonaGrill> = new RawAliasReflection<LynxSedonaGrill>(
  'LynxSedonaGrill',
  [LynxSedonaGrillW30, LynxSedonaGrillW36, LynxSedonaGrillW42]
)

export type LynxGrill = LynxProfessionalGrill | LynxSedonaGrill
export const LynxGrill: RawAliasReflection<LynxGrill> = new RawAliasReflection<LynxGrill>('LynxGrill', [
  ...LynxProfessionalGrill.reflections,
  ...LynxSedonaGrill.reflections,
])

export type LynxProfessionalBurner =
  | LynxProfessionalSingleBurner
  | LynxProfessionalDoubleBurner
  | LynxProfessionalPowerBurner
export const LynxProfessionalBurner: RawAliasReflection<LynxProfessionalBurner> =
  new RawAliasReflection<LynxProfessionalBurner>('LynxProfessionalBurner', [
    LynxProfessionalSingleBurner,
    LynxProfessionalDoubleBurner,
    LynxProfessionalPowerBurner,
  ])

export type LynxSedonaBurner = LynxSedonaSingleBurner | LynxSedonaDoubleBurner
export const LynxSedonaBurner: RawAliasReflection<LynxSedonaBurner> = new RawAliasReflection<LynxSedonaBurner>(
  'LynxSedonaBurner',
  [LynxSedonaSingleBurner, LynxSedonaDoubleBurner]
)

export type LynxBurner = LynxProfessionalBurner | LynxSedonaBurner
export const LynxBurner: RawAliasReflection<LynxBurner> = new RawAliasReflection<LynxBurner>('LynxBurner', [
  ...LynxProfessionalBurner.reflections,
  ...LynxSedonaBurner.reflections,
])

export type LynxProfessionalTapTowerKit = LynxProfessionalSingleTapTowerKit | LynxProfessionalDoubleTapTowerKit
export const LynxProfessionalTapTowerKit: RawAliasReflection<LynxProfessionalTapTowerKit> =
  new RawAliasReflection<LynxProfessionalTapTowerKit>('LynxProfessionalTapTowerKit', [
    LynxProfessionalSingleTapTowerKit,
    LynxProfessionalDoubleTapTowerKit,
  ])

export type ApplianceWithPowderCoating = LynxGrill | LynxAsadoGriddgle | LynxBurner | LynxWarmingDrawer
export const ApplianceWithPowderCoating: RawAliasReflection<ApplianceWithPowderCoating> =
  new RawAliasReflection<ApplianceWithPowderCoating>('ApplianceWithPowderCoating', [
    ...LynxGrill.reflections,
    LynxAsadoGriddgle,
    ...LynxBurner.reflections,
    LynxWarmingDrawer,
  ])

export type ResizableWallItem =
  | Drawer33Door66
  | GrillBase
  | Filler
  | FullDoorBase
  | SinkBase
  | ThreeDrawerBase
  | TrashPulloutBase
export const ResizableWallItem: RawAliasReflection<ResizableWallItem> = new RawAliasReflection<ResizableWallItem>(
  'ResizableWallItem',
  [Drawer33Door66, GrillBase, Filler, FullDoorBase, SinkBase, ThreeDrawerBase, TrashPulloutBase]
)

export type LynxSedonaHood = LynxSedonaHoodW36 | LynxSedonaHoodW42 | LynxSedonaHoodW48
export const LynxSedonaHood: RawAliasReflection<LynxSedonaHood> = new RawAliasReflection<LynxSedonaHood>(
  'LynxSedonaHood',
  [LynxSedonaHoodW36, LynxSedonaHoodW42, LynxSedonaHoodW48]
)

export type Hood = LynxSedonaHood
export const Hood: RawAliasReflection<Hood> = new RawAliasReflection<Hood>('Hood', [...LynxSedonaHood.reflections])

export type Appliance = TopAppliance | BottomAppliance
export const Appliance: RawAliasReflection<Appliance> = new RawAliasReflection<Appliance>('Appliance', [
  ...TopAppliance.reflections,
  ...BottomAppliance.reflections,
])

export const aliases = {
  AnyDomainEntity: AnyDomainEntity.types,
  RootEntity: RootEntity.types,
  StaticEntity: StaticEntity.types,
  BurnerBase: BurnerBase.types,
  AdjustableDoorCabinet: AdjustableDoorCabinet.types,
  TopAppliance: TopAppliance.types,
  LynxSink: LynxSink.types,
  BottomAdjustableDoorAppliance: BottomAdjustableDoorAppliance.types,
  BottomNonAdjustableDoorAppliance: BottomNonAdjustableDoorAppliance.types,
  BottomCabinetAppliance: BottomCabinetAppliance.types,
  BottomWallAppliance: BottomWallAppliance.types,
  BottomAppliance: BottomAppliance.types,
  SwatchPowderCoatableRoomItem: SwatchPowderCoatableRoomItem.types,
  PulsePowderCoatableRoomItem: PulsePowderCoatableRoomItem.types,
  BottomCabinet: BottomCabinet.types,
  BottomCabinetWithAppliance: BottomCabinetWithAppliance.types,
  BottomCabinetWithoutAppliance: BottomCabinetWithoutAppliance.types,
  BottomCabinetWithDefaultDetail: BottomCabinetWithDefaultDetail.types,
  BottomPart: BottomPart.types,
  BottomWallItemWithDefaultCountertop: BottomWallItemWithDefaultCountertop.types,
  BottomWallItemWithCustomCountertop: BottomWallItemWithCustomCountertop.types,
  BottomWallItemWithDefaultToeKick: BottomWallItemWithDefaultToeKick.types,
  BottomWallItemWithCustomToeKick: BottomWallItemWithCustomToeKick.types,
  BottomWallItemWithBackPanel: BottomWallItemWithBackPanel.types,
  RoomItem: RoomItem.types,
  RoomItemWithDefaultPrice: RoomItemWithDefaultPrice.types,
  RoomItemWithDefaultSummary: RoomItemWithDefaultSummary.types,
  BottomWallItem: BottomWallItem.types,
  TopWallItem: TopWallItem.types,
  WallItem: WallItem.types,
  LynxProfessionalGrill: LynxProfessionalGrill.types,
  LynxSedonaGrill: LynxSedonaGrill.types,
  LynxGrill: LynxGrill.types,
  LynxProfessionalBurner: LynxProfessionalBurner.types,
  LynxSedonaBurner: LynxSedonaBurner.types,
  LynxBurner: LynxBurner.types,
  LynxProfessionalTapTowerKit: LynxProfessionalTapTowerKit.types,
  ApplianceWithPowderCoating: ApplianceWithPowderCoating.types,
  ResizableWallItem: ResizableWallItem.types,
  LynxSedonaHood: LynxSedonaHood.types,
  Hood: Hood.types,
  Appliance: Appliance.types,
} as const
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export type Aliases = {
  AnyDomainEntity: AnyDomainEntity
  RootEntity: RootEntity
  StaticEntity: StaticEntity
  BurnerBase: BurnerBase
  AdjustableDoorCabinet: AdjustableDoorCabinet
  TopAppliance: TopAppliance
  LynxSink: LynxSink
  BottomAdjustableDoorAppliance: BottomAdjustableDoorAppliance
  BottomNonAdjustableDoorAppliance: BottomNonAdjustableDoorAppliance
  BottomCabinetAppliance: BottomCabinetAppliance
  BottomWallAppliance: BottomWallAppliance
  BottomAppliance: BottomAppliance
  SwatchPowderCoatableRoomItem: SwatchPowderCoatableRoomItem
  PulsePowderCoatableRoomItem: PulsePowderCoatableRoomItem
  BottomCabinet: BottomCabinet
  BottomCabinetWithAppliance: BottomCabinetWithAppliance
  BottomCabinetWithoutAppliance: BottomCabinetWithoutAppliance
  BottomCabinetWithDefaultDetail: BottomCabinetWithDefaultDetail
  BottomPart: BottomPart
  BottomWallItemWithDefaultCountertop: BottomWallItemWithDefaultCountertop
  BottomWallItemWithCustomCountertop: BottomWallItemWithCustomCountertop
  BottomWallItemWithDefaultToeKick: BottomWallItemWithDefaultToeKick
  BottomWallItemWithCustomToeKick: BottomWallItemWithCustomToeKick
  BottomWallItemWithBackPanel: BottomWallItemWithBackPanel
  RoomItem: RoomItem
  RoomItemWithDefaultPrice: RoomItemWithDefaultPrice
  RoomItemWithDefaultSummary: RoomItemWithDefaultSummary
  BottomWallItem: BottomWallItem
  TopWallItem: TopWallItem
  WallItem: WallItem
  LynxProfessionalGrill: LynxProfessionalGrill
  LynxSedonaGrill: LynxSedonaGrill
  LynxGrill: LynxGrill
  LynxProfessionalBurner: LynxProfessionalBurner
  LynxSedonaBurner: LynxSedonaBurner
  LynxBurner: LynxBurner
  LynxProfessionalTapTowerKit: LynxProfessionalTapTowerKit
  ApplianceWithPowderCoating: ApplianceWithPowderCoating
  ResizableWallItem: ResizableWallItem
  LynxSedonaHood: LynxSedonaHood
  Hood: Hood
  Appliance: Appliance
}

export const entities: EntityReflections<AnyDomainEntity> = {
  BurnerBaseW18,
  BurnerBaseW24,
  LoweredBurnerBaseW24,
  CornerFiller,
  Drawer33Door66,
  EvoBaseW36,
  EvoAffinity25G,
  EvoAffinity30G,
  EndPanel,
  Filler,
  FullDoorBase,
  GrillBase,
  KamadoGrillBase,
  LynxAsadoGriddgle,
  LynxKamadoGrill,
  LynxProfessionalCocktailStation,
  LynxProfessionalGrillW30,
  LynxProfessionalGrillW36,
  LynxProfessionalGrillW42,
  LynxProfessionalGrillW54,
  LynxProfessionalSingleBurner,
  LynxProfessionalDoubleBurner,
  LynxProfessionalPowerBurner,
  LynxProfessionalOutdoorBeverageDispenserW24,
  LynxProfessionalRefrigeratorFreezerComboW24,
  LynxProfessionalOutdoorRefrigeratorW24,
  LynxProfessionalOutdoorRefrigeratorWithGlassDoorW24,
  LynxProfessionalRefrigeratorW15,
  LynxProfessionalWineCellarW15,
  LynxProfessionalTwoDrawerRefrigeratorW24,
  LynxProfessionalOutdoorIceMachineW15,
  LynxProfessionalOutdoorIceMachineDrainPump,
  LynxProfessionalSingleTapTowerKit,
  LynxProfessionalDoubleTapTowerKit,
  LynxSedonaGrillW30,
  LynxSedonaGrillW36,
  LynxSedonaGrillW42,
  LynxSedonaSingleBurner,
  LynxSedonaDoubleBurner,
  LynxSedonaHoodW36,
  LynxSedonaHoodW42,
  LynxSedonaHoodW48,
  LynxSinkW18,
  LynxSinkW24,
  LynxSinkW30,
  LynxWarmingDrawer,
  Room,
  RearPanel,
  SinkBase,
  ThreeDrawerBase,
  TrashPulloutBase,
  Wall,
} as const
